import {ScrollTrigger} from "../LibrariesImport";

export default class AppearOnScroll {

	static init() {
		const delayLoop = (fn, delay) => {
			return (x, i) => {
				setTimeout(() => {
					fn(x);
				}, i * delay);
			};
		};

		const appear = a => a.classList.add('appeared');

		const dataAos = document.querySelectorAll('[data-aos]');
		dataAos.forEach((el) => {
			ScrollTrigger.create({
				trigger: el,
				start: 'top 90%',
				once: true,
				toggleClass: "appeared"
			});
		});


		const linesTop = document.querySelectorAll('.line-top');
		ScrollTrigger.batch(linesTop, {
			start: 'top 90%',
			once: true,
			onEnter: elements => {
				elements.forEach(delayLoop(appear, 250));
			},
		});

		const linesBottom = document.querySelectorAll('.line-bottom');
		ScrollTrigger.batch(linesBottom, {
			start: 'bottom 90%',
			once: true,
			onEnter: elements => {
				elements.forEach(delayLoop(appear, 250));
			},
		});


		const images = document.querySelectorAll('.image-reveal');
		ScrollTrigger.batch(images, {
			start: 'top 90%',
			once: true,
			onEnter: elements => {
				elements.forEach(delayLoop(appear, 350));
			},
		});
	}
}
